import { NavLink, useNavigate } from "react-router-dom";
import { LogOut, Menu } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Brand, SimNotice } from "@/components/Brand";

const links = [
  ["/", "Accounts"], ["/transfer", "Pay & Transfer"], ["/billpay", "Bill Pay"],
  ["/invest", "Investing"], ["/statements", "Statements"],
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const all = user.role === "admin" ? [...links, ["/admin", "Admin"]] : links;
  const cls = ({ isActive }) =>
    `px-3 py-2 text-sm font-semibold rounded-md transition-colors ${isActive ? "bg-white/15 text-white" : "text-white/80 hover:text-white hover:bg-white/10"}`;

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-[var(--navy)] sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
          <Brand light />
          <nav className="hidden lg:flex gap-1" data-testid="main-nav">
            {all.map(([to, label]) => (
              <NavLink key={to} to={to} end={to === "/"} className={cls} data-testid={`nav-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{label}</NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            <button onClick={async () => { await logout(); nav("/login"); }} className="hidden sm:flex items-center gap-2 text-sm font-semibold text-white bg-[var(--red)] hover:bg-[#a50d26] px-4 py-2 rounded-full transition-colors" data-testid="logout-button">
              <LogOut size={15} /> Sign out
            </button>
            <button className="lg:hidden text-white p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle"><Menu /></button>
          </div>
        </div>
        <div className="h-1 bg-[var(--red)]" />
        {open && (
          <div className="lg:hidden bg-[var(--navy)] px-4 pb-4 flex flex-col gap-1" data-testid="mobile-nav">
            {all.map(([to, label]) => <NavLink key={to} to={to} end={to === "/"} className={cls} onClick={() => setOpen(false)}>{label}</NavLink>)}
            <button onClick={async () => { await logout(); nav("/login"); }} className="text-left px-3 py-2 text-sm font-semibold text-white/80" data-testid="mobile-logout-button">Sign out</button>
          </div>
        )}
      </header>
      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-8 py-8 sm:py-12">{children}</main>
      <footer className="border-t bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3">
          <span className="text-xs text-slate-500">© 2022 Maderian Us Serve</span>
          <SimNotice />
        </div>
      </footer>
    </div>
  );
}
